import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateUploadComponent } from './template-upload.component';



@NgModule({
  declarations: [TemplateUploadComponent],
  imports: [
    CommonModule
  ],
  exports: [TemplateUploadComponent]
})
export class TemplateUploadModule { }
